import { useMutation } from "@tanstack/react-query";
import { HTTPError } from "ky";

import { useApi } from "../client";
import { ModuleCommandEnum } from "../events/modules/command.enum";

export const useSendCommand = ({ areaId }: { areaId: string }) => {
  const api = useApi();

  return useMutation({
    mutationFn: async ({
      destinationAddress,
      command,
    }: {
      destinationAddress: string;
      command: ModuleCommandEnum;
    }) => {
      const requestOptions = {
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          areaId,
          destinationAddress: Number(destinationAddress),
          command,
        }),
      };
      const response = await api.post(
        `module-interactions/send-command`,
        requestOptions
      );

      return response.json();
    },
    onSuccess: async () => {
      console.log("success");
    },
    onError: async (error) => {
      /**
       * Receiving a "409 - Conflict" response means we tried to perform an action the post can not do
       * (i.e. we sent "DEPLOY" but the post is already deployed or pending deployment).
       * This means our local data is probably not in sync with the server. We want to invalidate the query and refetch.
       */
      if (error instanceof HTTPError && error.response.status === 409) {
        console.log("error 409");
      }
    },
  });
};
